

import { Node } from '@tiptap/core'
import { ClearActionButton } from '@/tiptap/extensions/components/ActionButton'

export const Clear = Node.create({
  name: 'clear',

  addOptions() {
    return {
      ...(this.parent ? this.parent() : {}),
      button: ({ editor, t }) => ({
        component: ClearActionButton,
        componentProps: { editor, t }
      })
    }
  }
})

export default Clear